export class CloudLinkResponseModel {
    public xmlData: Element | null = null;
    public jsonData: any | null = null;
}